import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GaTrackingVolumePriceTableClickedEvent implements GATrackingEvent {

  constructor(private label: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.VolumePriceTableClick;
  }

  getPayload(): GATrackingEventPayload {

    return {
      event: GaTrackingEventName.VolumePricingTableClicked,
      label: this.label,
      gtmCustom: {
        category: GaTrackingEventCategory.Interaction
      }
    };
  }
}
